import React, { FunctionComponent } from 'react';

import { pageDate } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import PageSectionCards from 'components/page/sections/page-section-cards';

export const DateBlockTwoContainer: FunctionComponent = () => {
  const props = {
    title: pageDate.lxPageDateThreeBlockTitle,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/photos/date-blog-1.jpg`,
        title: pageDate.lxPageDateThreeBlockOneItemTitle,
        text: pageDate.lxPageDateThreeBlockOneItemText,
        href: '/the-buzz/emotional-intimacy-in-a-relationship',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/photos/date-blog-2.jpg`,
        title: pageDate.lxPageDateThreeBlockTwoItemTitle,
        text: pageDate.lxPageDateThreeBlockTwoItemText,
        href: '/the-buzz/bumble-deception-detector',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/photos/date-blog-3.jpg`,
        title: pageDate.lxPageDateThreeBlockThreeItemTitle,
        text: pageDate.lxPageDateThreeBlockThreeItemText,
        href: '/the-buzz/never-used-bumble-before',
      },
      // @TODO: later to add
      // {
      //     title: pageDate.lxPageDateThreeBlockFourItemTitle,
      //     text: pageDate.lxPageDateThreeBlockFourItemText,
      // },
    ],
  };

  return (
    <PageSectionCards title={props.title} cards={props.items} color="orange" styling="filled" />
  );
};
